// extracted by mini-css-extract-plugin
export default {"footer":"NuKbDO","moreItemsText":"pj1wIz","mobileFooter":"LxAREf"};